import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchSingleJob } from "../../features/GetSingleJob/GetSingleJobSlice";
import { FetchEditJob } from "../../features/UpdateJobs/UpdateJobsSlice";

const EditJob = () => {
  const dispatch = useDispatch();
  const { jobId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchSingleJob(jobId));
  }, [dispatch, jobId]);

  const { singleJob, isError, isLoading, error } = useSelector(
    (state) => state.getSingleJob
  );

  let { id, title, type, salary, deadline } = singleJob;

  const [newSalary, setNewSalary] = useState(salary);
  const [newDeadline, setNewDeadline] = useState(deadline);

  const handleSalary = (e) => {
    setNewSalary(e.target.value);
  };
  const handleDeadline = (e) => {
    setNewDeadline(e.target.value);
  };

  useEffect(() => {
    if (id == jobId) {
      setNewSalary(salary);
      setNewDeadline(deadline);
    }
  },[id, jobId, salary, deadline])

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedData = {
      title: e.target.elements.lwsJobTitle.value,
      type: e.target.elements.lwsJobType.value,
      salary: e.target.elements.lwsJobSalary.value,
      deadline: e.target.elements.lwsJobDeadline.value,
    };
    dispatch(FetchEditJob({id:jobId, updatedValue:updatedData}))
    .then(() => navigate("/"))
  };

  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>

      <div className="max-w-3xl mx-auto">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select id="lws-JobTitle" name="lwsJobTitle" required>
              <option value="" hidden>
                Select Job
              </option>
              <option
                selected={title === "Software Engineer"}
                value="Software Engineer"
              >
                Software Engineer
              </option>
              <option
                selected={title === "Software Developer"}
                value="Software Developer"
              >
                Software Developer
              </option>
              <option
                selected={title === "Full Stack Developer"}
                value="Full Stack Developer"
              >
                Full Stack Developer
              </option>
              <option
                selected={title === "MERN Stack Developer"}
                value="MERN Stack Developer"
              >
                MERN Stack Developer
              </option>
              <option
                selected={title === "DevOps Engineer"}
                value="DevOps Engineer"
              >
                DevOps Engineer
              </option>
              <option selected={title === "QA Engineer"} value="QA Engineer">
                QA Engineer
              </option>
              <option
                selected={title === "Product Manager"}
                value="Product Manager"
              >
                Product Manager
              </option>
              <option
                selected={title === "Social Media Manager"}
                value="Social Media Manager"
              >
                Social Media Manager
              </option>
              <option
                selected={title === "Senior Executive"}
                value="Senior Executive"
              >
                Senior Executive
              </option>
              <option
                selected={title === "Junior Executive"}
                value="Junior Executive"
              >
                Junior Executive
              </option>
              <option
                selected={title === "Android App Developer"}
                value="Android App Developer"
              >
                Android App Developer
              </option>
              <option
                selected={title === "IOS App Developer"}
                value="IOS App Developer"
              >
                IOS App Developer
              </option>
              <option
                selected={title === "Frontend Developer"}
                value="Frontend Developer"
              >
                Frontend Developer
              </option>
              <option
                selected={title === "Frontend Engineer"}
                value="Frontend Engineer"
              >
                Frontend Engineer
              </option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              defaultValue={type}
              id="lws-JobType"
              name="lwsJobType"
              required
            >
              <option value="" hidden selected>
                Select Job Type
              </option>
              <option selected={type === "Full Time"}>Full Time</option>
              <option selected={type === "Internship"}>Internship</option>
              <option selected={type === "Remote"}>Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                type="number"
                name="lwsJobSalary"
                id="lws-JobSalary"
                required
                className="!rounded-l-none !border-0"
                value={newSalary}
                onChange={(e) => handleSalary(e)}
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              type="date"
              value={newDeadline}
              onChange={handleDeadline}
              name="lwsJobDeadline"
              id="lws-JobDeadline"
              required
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              className="cursor-pointer btn btn-primary w-fit"
            >
              Edit
            </button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default EditJob;
